import styled from "styled-components";

export const Title = styled.h1`
      color: var(--border);
      background:transparent;
      font-size: ${props => props.fontSize ? props.fontSize : '30px'};
      margin-top:10px;
      letter-spacing:1.1px;
      font-weight:500;
      text-align:center;
      text-shadow: -4px 0px 50px gold;
      text-decoration: underline;
      text-underline-offset: 4px;

      @media screen and (max-width: 500px) {
            font-size:22px;
      }
`